import React from 'react';
import aboutImg from '../images/baseball_img.png';
import { withRouter } from "react-router-dom";

//import { makeStyles } from '@material-ui/core/styles';


//material ui-theme - move to central location
/*
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
}));
*/

function About() {
    //const classes = useStyles();
    return (
        <div id="about" className="">
            <div id="about" className="container-fluid pt-5">
                <h1 className="mx-auto">ABOUT US</h1>
            </div>
            <div className="row mt-3">
                <div className="col-12 col-sm-12	col-md-12	col-lg-6	col-xl-6	col-xxl-6 align-self-center" >

                    <div className="container w-75 p-4 mx-auto">
                        <p className="my-auto">
                            Student Athlete Camps, a KJK Sports, LLC company, is your one-stop shop for starting and operating a successful camp or event!
                            <br /><br />Founded shortly after the NIL legislation passed, SAC is excited to offer multiple packages to athletes in the quest to build their brand and run camps while still competing in college.
                            <br /><br /><b className="primary"><i>Our white glove service and support helps this otherwise daunting task become an easy reality.</i></b>
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-12	col-md-12	col-lg-6	col-xl-6	col-xxl-6" >
                    <img className="mx-auto w-75 d-block rounded-circle" alt="Coaching child on baseball" src={aboutImg} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <h2 className="mx-auto">Services</h2>
                </div>
                <div className="col-12 col-sm-12	col-md-12	col-lg-6	col-xl-6	col-xxl-6">
                    <ul className="list-group mx-auto w-75 list-group-flush">
                        <li className="list-group-item"><b>Website and online registration.</b><br /> Having this option for campers to sign up is a simple process designed to save you time, effort, and money. Having online registration will eliminate inordinate amounts of paperwork, while also making the user experience a painless one for parents.</li>
                        <li className="list-group-item"><b>Business creation.</b> <br /> No need to start your own LLC. This will eliminate legal fees, paperwork, accounting questions and many other business components that KJK will take care of!</li>
                        <li className="list-group-item"><b>Insurance.</b><br />  We take care of your camp insurance. The headaches and costs associated with garnering insurance for your event will be taken care of. Regardless of venue, sport or size of camp, we’ll have you covered.</li>
                        <li className="list-group-item"><b>Facilities.</b><br />  Allow us to assist or take the responsibility of finding you the best fit for a camp location. Be it near your hometown or your current college location, we want to help you secure the best spot to host your camp.</li>

                    </ul>
                    </div>
                    <div className="col-12 col-sm-12	col-md-12	col-lg-6	col-xl-6	col-xxl-6">
                    <ul className="list-group mx-auto w-75 list-group-flush">
                        <li className="list-group-item"><b>Liability waivers.</b><br />  These can cost plenty of money to create and complete before a camp. We have this taken care of, too, and will confer with our legal counsel to ensure it’s right for your camp.
                        </li>
                        <li className="list-group-item"><b>Marketing.</b> <br /> Consult with the KJK team to figure out what best suits your camp needs. Social media. Local radio and newspaper. Whatever is the right fit, we’ll do our best to help publicize your camp and ultimately bring you more campers.
                        </li>
                        <li className="list-group-item"><b>T-shirts.</b> <br /> Use our partnerships to get your campers a souvenir they’ll wear for years to come.
                        </li>
                        <li className="list-group-item"><b>Agenda.</b><br /> Help with generating a camp agenda/itinerary</li>
                    </ul>
                </div>
            </div>

        </div>
    );
}

export default withRouter(About);









